export const INPUT_NAMES = {
  NAME: 'name',
  EMAIL: 'email',
  DATE: 'date',
};
